import { createSlice } from "@reduxjs/toolkit";
import {
  AcceptRefferal,
  fetchReferralByVendorId,
  fetchReferralsItems,
  RejectedRefferal,
} from "./ReferralsThunks";

// Redux slice with pagination support
const initialState = {
  items: [],
  acceptLoading: false,
  rejectLoading: false,
  loading: false,
  error: null,
  hasMore: true,
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
  searchQuery: "",
};

const referralsSlice = createSlice({
  name: "referrals",
  initialState,
  reducers: {
    resetReferrals: (state) => {
      state.items = [];
      state.currentPage = 1;
      state.hasMore = true;
      state.totalPages = 0;
      state.totalCount = 0;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      // Reset pagination when search changes
      state.items = [];
      state.currentPage = 1;
      state.hasMore = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferralsItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralsItems.fulfilled, (state, action) => {
        state.loading = false;
        const { data, page, totalPages, total, hasNextPage, isLoadMore } =
          action.payload;

        if (isLoadMore) {
          // Append new data for pagination
          state.items = [...state.items, ...data];
        } else {
          // Replace data for initial load or search
          state.items = data;
        }

        state.currentPage = page;
        state.totalPages = totalPages;
        state.totalCount = total;
        state.hasMore = hasNextPage;
      })
      .addCase(fetchReferralsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchReferralByVendorId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralByVendorId.fulfilled, (state, action) => {
        state.loading = false;
        const { data, page, totalPages, total, hasNextPage, isLoadMore } =
          action.payload;

        if (isLoadMore) {
          state.items = [...state.items, ...data];
        } else {
          state.items = data;
        }

        state.currentPage = page;
        state.totalPages = totalPages;
        state.totalCount = total;
        state.hasMore = hasNextPage;
      })
      .addCase(fetchReferralByVendorId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(AcceptRefferal.pending, (state) => {
        state.acceptLoading = true;
        state.error = null;
      })
      .addCase(AcceptRefferal.fulfilled, (state, action) => {
        state.acceptLoading = false;
        state.error = null;
      })
      .addCase(AcceptRefferal.rejected, (state) => {
        state.acceptLoading = false;
        state.error = true;
      })
      .addCase(RejectedRefferal.pending, (state) => {
        state.rejectLoading = true;
        state.error = null;
      })
      .addCase(RejectedRefferal.fulfilled, (state, action) => {
        state.rejectLoading = false;
        state.error = null;
      })
      .addCase(RejectedRefferal.rejected, (state) => {
        state.rejectLoading = false;
        state.error = true;
      });
  },
});

export const { resetReferrals, setSearchQuery } = referralsSlice.actions;
export default referralsSlice.reducer;
